import { createContext  } from "react";

const nodeContext = createContext();

export default nodeContext;